import { DEFAULT_DIALOG_CONFIG } from '@angular/cdk/dialog';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  LOCALE_ID,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  PreloadAllModules,
  provideRouter,
  withPreloading,
} from '@angular/router';
import { provideStore } from '@ngrx/store';
import {
  AutoRefreshTokenService,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { AuthInterceptor } from '@infrastructure/inteceptor/auth.interceptor';
import { provideDayLuxonDateProvider } from '@infrastructure/providers/day-luxon-date.provider';
import { TabActivityService } from '@infrastructure/services/tab-activity-service';
import { provideCommonStore } from '@store-common/common.module';
import { environment } from '../environments/environment';
import routes from './routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimations(),
    provideStore(),
    provideCommonStore(),
    {
      provide: DEFAULT_DIALOG_CONFIG,
      useValue: {
        backdropClass: ['backdrop-white'],
      },
    },
    {
      provide: LOCALE_ID,
      useValue: 'ru-RU',
    },
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideZonelessChangeDetection(),
    provideKeycloak({
      config: {
        clientId: 'custody-rest-api',
        realm: 'Custody',
        url: environment.keycloak,
      },
      features: [
        withAutoRefreshToken({
          onInactivityTimeout: 'logout',
          sessionTimeout: 300000,
        }),
      ],
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoFallback: false,
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/html/check-sso.html',
      },
      providers: [
        AutoRefreshTokenService,
        {
          multi: false,
          provide: UserActivityService,
          useClass: TabActivityService,
        },
      ],
    }),
    provideDayLuxonDateProvider({
      display: {
        dateA11yLabel: 'LL',
        dateInput: 'yyyy-MM-dd',
        monthYearA11yLabel: 'MMMM yyyy',
        monthYearLabel: 'MMM yyyy',
      },
      parse: {
        dateInput: 'yyyy-MM-dd',
      },
    }),
    environment.providers,
  ],
};
